import React, { useContext, useEffect} from 'react';
import io from "socket.io-client";
import ViewingCanvas from "../components/ViewingCanvas";
import { SocketContext } from '../components/SocketContext';
import { useLocation } from 'react-router-dom';


const View = () => {
  const socket = useContext(SocketContext);
  let navigateData = useLocation();
  const roomName = navigateData.state.name;
  console.log("room name " + roomName);
  
  useEffect(() => {
    socket.emit("joinroom", {"room": roomName, "username": "testuser"});  
  }, [socket]);

  function handleClickJoinRoom(){
    if (socket){
      socket.emit("joinroom", {"room": roomName, "username": "testuser"});
    }
  }

  function handleClickLeaveRoom(){
    if (socket){
      socket.emit("leaveroom", {"room": roomName, "username": "testuser"});
    }
  }

  return (
    <div className="View">
      {socket ? (
        <>
          <button onClick={handleClickJoinRoom}>Join room!</button>
          <button onClick={handleClickLeaveRoom}>Leave room!</button>
          <ViewingCanvas socket={socket} />
        </>
      ) : <div>Connecting...</div>}
    </div>
  );
};

export default View;